import { render, staticRenderFns } from "./clientRoutes.vue?vue&type=template&id=4a0a0971&"
import script from "./clientRoutes.vue?vue&type=script&lang=js&"
export * from "./clientRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports